/* eslint-disable @typescript-eslint/no-explicit-any */
import { Stack, Typography } from '@mui/material';
import { BarChart } from '@stack/ui/components';

export type ChargingTimeGraphProps = {
  data: any;
};

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const ChargingTimeGraph: React.FC<ChargingTimeGraphProps> = (props) => {
  const { data } = props;

  const convertTimeToHours = (timeString: string | null): number | null => {
    if (!timeString) return null;

    const hoursMatch = timeString.match(/(\d+)\s*hours?/i);
    const minutesMatch = timeString.match(/(\d+)\s*minutes?/i);

    let hours = 0;
    let minutes = 0;

    if (hoursMatch) {
      hours = parseInt(hoursMatch[1]);
    }

    if (minutesMatch) {
      minutes = parseInt(minutesMatch[1]);
    }

    const totalHours = hours + minutes / 60;
    return totalHours === 0 ? null : totalHours;
  };

  const acChargingTime = data?.map((time: any) =>
    convertTimeToHours(time.acChargingTime)
  );
  const dcChargingTime = data?.map((time: any) =>
    convertTimeToHours(time.dcChargingTime)
  );
  const fuelType = data?.map((fuel: any) => fuel.car_fuel_type_slug);

  const hasPetrol = fuelType.includes('petrol');
  const isEmptyChargingTime =
    (acChargingTime.every((time: any) => time === null) &&
      dcChargingTime.every((time: any) => time === null)) ||
    hasPetrol;

  if (isEmptyChargingTime) return null;

  return (
    <Stack
      sx={{
        border: '1px solid #EDECED',
        display: 'flex',
        padding: 5,
        marginTop: 5,
      }}
    >
      <Stack
        sx={{
          paddingBottom: {
            xs: 6,
            lg: '1rem',
          },
        }}
      >
        <Typography fontWeight={700} fontSize="1rem" color="#374255" pb={6}>
          Charging Time between Variant
        </Typography>

        <Stack>
          <BarChart
            colors={['#00B4D0', '#FF9900']}
            data={{
              labels: data?.map((label: any) => label.carTitle),
              series: [
                {
                  label: 'DC Charging',
                  data: dcChargingTime,
                  name: 'DC Charging', // tooltip naming
                },
                {
                  label: 'AC Charging',
                  data: acChargingTime,
                  name: 'AC Charging', // tooltip naming
                },
              ],
              total: 12,
              title: 'Hours',
            }}
          />
        </Stack>
      </Stack>
    </Stack>
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export default ChargingTimeGraph;
